/* Zambezi Roots — theme-side analytics readiness layer.
   Dispatches sanitised CustomEvents only. No network calls, no PII, no storage. */
(function () {
  'use strict';

  if (window.ZRAnalytics && window.ZRAnalytics.__init) return;

  var PII_KEY = /^(email|e_mail|phone|tel|name|first_name|last_name|full_name|address|street|city|postcode|postal|zip|message|body|note|order_number|customer_id|user_id|token|cart_token|checkout_token|password|organisation|organization|company|query|search_term|search_terms|q|terms|honeypot)$/i;
  var RECENT = Object.create(null);
  var DEDUPE_MS = 450;

  function designMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function pageType() {
    var match = document.body && document.body.className.match(/template-(\w+)/);
    return match ? match[1] : 'unknown';
  }

  function currencyCode() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return String(window.Shopify.currency.active);
    }
    return 'AUD';
  }

  function isPlainObject(val) {
    return val !== null && typeof val === 'object' && !Array.isArray(val) && !(val instanceof Date);
  }

  function sanitizeValue(key, val, depth) {
    if (val == null || val === '') return undefined;
    if (depth > 4) return undefined;
    if (typeof val === 'function' || val instanceof Node || val instanceof Event) return undefined;
    if (typeof key === 'string' && PII_KEY.test(key)) return undefined;

    if (Array.isArray(val)) {
      var list = [];
      for (var i = 0; i < val.length && i < 12; i++) {
        var item = sanitizeValue(String(i), val[i], depth + 1);
        if (item !== undefined) list.push(item);
      }
      return list.length ? list : undefined;
    }

    if (isPlainObject(val)) {
      var obj = {};
      Object.keys(val).slice(0, 24).forEach(function (k) {
        var next = sanitizeValue(k, val[k], depth + 1);
        if (next !== undefined) obj[k] = next;
      });
      return Object.keys(obj).length ? obj : undefined;
    }

    if (typeof val === 'string') {
      if (val.indexOf('@') !== -1) return undefined;
      if (/^https?:\/\/.+[?&](email|token|key)=/i.test(val)) return undefined;
      return val.length > 180 ? val.slice(0, 180) : val;
    }

    if (typeof val === 'number') {
      if (!isFinite(val)) return undefined;
      return val;
    }

    if (typeof val === 'boolean') return val;
    return undefined;
  }

  function buildDetail(detail) {
    var clean = sanitizeValue('detail', detail || {}, 0) || {};
    clean.page_type = pageType();
    if (designMode()) clean.theme_editor = true;
    if (!clean.currency) clean.currency = currencyCode();
    clean.ts = Date.now();
    return clean;
  }

  function dedupeKey(name, detail) {
    return [
      name,
      detail.source || '',
      detail.product_id || '',
      detail.variant_id || '',
      detail.quantity || '',
      detail.action || ''
    ].join('|');
  }

  function shouldDedupe(name, detail) {
    if (name.indexOf('_view') !== -1 || name.indexOf('_open') !== -1) return false;
    var key = dedupeKey(name, detail);
    var now = Date.now();
    if (RECENT[key] && now - RECENT[key] < DEDUPE_MS) return true;
    RECENT[key] = now;
    return false;
  }

  function normaliseName(name) {
    if (!name || typeof name !== 'string') return '';
    if (name.indexOf('zr:') === 0) return name;
    if (name.indexOf('zr_') === 0) return 'zr:' + name.slice(3);
    return 'zr:' + name;
  }

  function emit(name, detail) {
    try {
      var eventName = normaliseName(name);
      if (!eventName || eventName === 'zr:') return false;
      var payload = buildDetail(detail);
      if (shouldDedupe(eventName, payload)) return false;
      document.dispatchEvent(new CustomEvent(eventName, {
        detail: payload,
        bubbles: false,
        cancelable: false
      }));
      return true;
    } catch (err) {
      return false;
    }
  }

  window.ZRAnalytics = {
    __init: true,
    emit: emit,
    pageType: pageType,
    designMode: designMode,
    currencyCode: currencyCode
  };
})();
